import React, { Children, cloneElement } from 'react';
import PropTypes from 'prop-types';
import MenuDivider from './MenuDivider';
import isUnstable from '../utils/isUnstable';

var MenuGroup = function MenuGroup(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      name = _ref.name;
  isUnstable('MenuGroup');
  return /*#__PURE__*/React.createElement("div", {
    role: "group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown__group__label"
  }, name), Children.map(children, function (child) {
    return cloneElement(child, {
      disabled: disabled
    });
  }), /*#__PURE__*/React.createElement(MenuDivider, null));
};

MenuGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired
};
MenuGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MenuGroup",
  "props": {
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "func"
        }]
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": ""
    }
  }
};
export default MenuGroup;